"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.configureWinstonLogger = void 0;
const winston = require("winston");
const WinstonLogger_1 = require("./WinstonLogger");
const default_1 = require("../default/default");
function configureWinstonLogger(options) {
    if (!options) {
        options = {
            format: winston.format.combine(winston.format.timestamp(), winston.format.json()),
            transports: [
                new winston.transports.Console({
                    level: "debug",
                    handleExceptions: true,
                }),
            ],
            exitOnError: false,
        };
    }
    default_1.defaultLogger.setDefaultLogger(new WinstonLogger_1.WinstonLogger(options));
}
exports.configureWinstonLogger = configureWinstonLogger;
//# sourceMappingURL=configureWinstonLogger.js.map